import React from "react";
import { FaEye } from "react-icons/fa";

const WalletTable = ({ transactions = [], onView }) => {
  return (
    <div className="luxury-table-container">
      <table className="luxury-table">
        <thead>
          <tr>
            <th>#</th>
            <th>User</th>
            <th>Amount</th>
            <th>Type</th>
            <th>Status</th>
            <th>Date</th>
            <th style={{ textAlign: 'center' }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {transactions.length === 0 ? (
            <tr>
              <td colSpan="7" style={{ textAlign: 'center', padding: '40px', color: '#a1a5b7' }}>
                No wallet transactions found.
              </td>
            </tr>
          ) : (
            transactions.map((tx, index) => {
              const isCredit = tx.type === "credit" || tx.type === "wallet_recharge" || tx.type === "refund";
              const statusColor = tx.status === 'completed' ? '#50cd89' : tx.status === 'failed' ? '#f1416c' : '#ffc700';
              
              return (
                <tr key={tx._id || tx.id || index}>
                  <td style={{ color: "#a1a5b7" }}>{index + 1}</td>
                  <td>
                     <div style={{ display: 'flex', flexDirection: 'column' }}>
                       <span style={{ fontWeight: "700", color: "#181c32" }}>{tx.user?.name || "-"}</span>
                       <span style={{ fontSize: '0.8rem', color: '#7e8299' }}>{tx.user?.email || ""}</span>
                     </div>
                  </td>
                  <td style={{ fontWeight: "700", color: isCredit ? "#50cd89" : "#f1416c" }}>
                    {isCredit ? "+" : "-"}₹{tx.amount}
                  </td>
                  <td>
                    <span className={`status-pill ${isCredit ? 'active' : 'inactive'}`}>
                      {tx.type?.replace("_", " ")}
                    </span>
                  </td>
                  <td>
                    <span style={{ 
                      padding: '4px 10px', 
                      borderRadius: '6px', 
                      fontSize: '0.75rem', 
                      fontWeight: '600',
                      backgroundColor: `${statusColor}20`,
                      color: statusColor,
                      textTransform: 'capitalize'
                    }}>
                      {tx.status || 'pending'}
                    </span>
                  </td>
                  <td>
                    {new Date(tx.createdAt).toLocaleDateString(undefined, {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric'
                    })}
                  </td>
                  <td>
                    <div className="table-actions" style={{ justifyContent: 'center' }}>
                       <button 
                         className="action-btn view" 
                         title="View Wallet Details"
                         onClick={() => onView && onView(tx)}
                       >
                         <FaEye />
                       </button>
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default WalletTable;
